<template>
  <v-card>
    <v-card-text>
      <v-switch v-model="discapacidad.isDiscapacidad" label="Seleccione si tiene alguna discapacidad reconocida"></v-switch>
    </v-card-text>
    <v-card-text v-if="discapacidad.isDiscapacidad">
      <v-divider></v-divider>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <v-radio-group v-model="discapacidad.tipo" @change="discapacidadTipo()">
              <v-radio
                label="Tipo i: Parálisis cerebral, enfermedad mental, discapacidad intelectual o discapacidad del desarrollo"
                value="i"
              ></v-radio>
              <v-divider class="py-2"></v-divider>
              <v-radio
                label="Tipo ii: Discapacidad física o sensorial"
                value="ii"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12>
            <v-slider label="Grado:" v-model="discapacidad.grado" thumb-label="always"></v-slider>
          </v-flex>
          <v-flex xs12>
            <v-switch v-model="discapacidad.documentoDiscapacidad" label="¿Tiene un documento acreditativo?"></v-switch>
          </v-flex>
          <v-flex xs12>
            <v-switch v-model="discapacidad.movilidad" label="¿Tiene movilidad reducida?"></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["discap"],
  data() {
    return {
      discapacidadOld: {
        isDiscapacidad: false,
        tipo: false,
        grado: 0,
        movilidad: false,
        documentoDiscapacidad: false
      },
      discapacidad: JSON.parse(JSON.stringify(this.discap)),
      disqui: this.discap
    }
  },
  watch: {
    changedDiscap(newValue) {
      if (newValue) {
        this.$emit('discapChange', this.discapacidad);
      }
    }
  },
  computed: {
    changedDiscap() {
      const int = JSON.stringify(this.discap);
      const out = JSON.stringify(this.discapacidad);
      return int !== out;
    }
  },
  methods: {
    discapacidadTipo() {
      const t = this.discapacidad.tipo;
      // this.discapacidad.tipo = t;
      if (t === "i") {
        this.discapacidad.grado = 33;
      } else {
        this.discapacidad.grado = 65;
      }
    }
  }
}
</script>
